import { useContext } from 'react';

import {
  AutopilotConfigContext,
  AutopilotConfigContextValue,
} from './autopilotConfigContextValue';

export const useAutopilotConfig = (): AutopilotConfigContextValue => {
  const context = useContext(AutopilotConfigContext);
  // Return undefined values if not within provider (fallback to old behavior)
  return context ?? { configurationId: undefined, version: undefined };
};
